(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rb-purchase-assurance"] && !Shopify.designMode) return;
  try {
    if (!window.rbWishlistTrackerLoaded) {
    window.rbWishlistTrackerLoaded = true;

    const STORAGE_KEY = 'rb_wishlist_items';
    const readWishlist = () => {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (error) {
        return [];
      }
    };

    const writeWishlist = (items) => {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      } catch (error) {
        return;
      }
    };

    const publishWishlistEvent = (name, payload) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: name,
        product_id: payload.product_id,
        product_title: payload.product_title,
        product_handle: payload.product_handle,
        variant_id: payload.variant_id,
        currency: payload.currency,
        value: payload.value,
      });

      document.dispatchEvent(new CustomEvent(name, { detail: payload }));

      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish(name, payload);
      }
    };

    const syncButton = (button) => {
      const label = button.querySelector('[data-rb-wishlist-label]');
      const wishlist = readWishlist();
      const saved = wishlist.some((item) => item.product_id === button.dataset.productId);

      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      if (label) {
        label.textContent = saved ? button.dataset.savedLabel : button.dataset.saveLabel;
      }
    };

    const buildPayload = (button) => ({
      product_id: button.dataset.productId,
      product_title: button.dataset.productTitle,
      product_handle: button.dataset.productHandle,
      product_url: button.dataset.productUrl,
      variant_id: button.dataset.variantId,
      currency: button.dataset.currency,
      value: Number(button.dataset.productPriceCents || 0) / 100,
      saved_at: new Date().toISOString(),
    });

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-rb-wishlist]');
      if (!button) return;

      const payload = buildPayload(button);
      const wishlist = readWishlist();
      const existingIndex = wishlist.findIndex((item) => item.product_id === payload.product_id);

      if (existingIndex >= 0) {
        wishlist.splice(existingIndex, 1);
        writeWishlist(wishlist);
        publishWishlistEvent('rb_wishlist_remove', payload);
      } else {
        wishlist.push(payload);
        writeWishlist(wishlist);
        publishWishlistEvent('rb_wishlist_add', payload);
      }

      syncButton(button);
    });

    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('[data-rb-wishlist]').forEach(syncButton);
    });

    document.querySelectorAll('[data-rb-wishlist]').forEach(syncButton);
  }
  } catch(e) { console.error(e); }
})();

})();
